import React from 'react';
import { TagContainer } from './styles';
import { Text } from '@fluentui/react-northstar';

interface TagProps {
  content: string;
  color: string;
  variant?: 'default' | 'outlined';
  compact?: boolean;
}

export const Tag = ({
  content,
  color,
  variant = 'default',
  compact = false,
}: TagProps) => {
  return (
    <TagContainer color={color} variant={variant} compact={compact}>
      <Text content={content} weight="bold" color="white" size="medium" />
    </TagContainer>
  );
};
